// To use the two-col layout, create a page with its DOM looking like this:
//
// <div class="page [page class]flex-container">
//  <div class="column left">
//    <div class="flex-inner">
//      [ left content ]
//    </div>
//  </div>
//  <div class="column right">
//    <div class="flex-inner">
//      [ right content ]
//    </div>
//  </div>
// </div>
import Menu from '@/components/menu/component'
import Notice from '@/components/notice/component'
import Foot from '@/components/foot/component'

export default {
  name: 'two-col-layout',
  props: ['menu', 'foot'],
  components: { Menu, Notice, Foot }
}



// WEBPACK FOOTER //
// ./src/layouts/two-col/script.js